import { Component, OnInit } from '@angular/core';
import * as jsPDF from 'jspdf';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { TccDetailService } from '../services/tcc-detail.service';
import { tap } from 'rxjs/operators';
import { Base64Images } from '../model/base64-images';


@Component({
  selector: 'app-download-tcc-cert',
  templateUrl: './download-tcc-cert.component.html',
  styleUrls: ['./download-tcc-cert.component.scss']
})
export class DownloadTccCertComponent implements OnInit {
  public tccdetail :ITccDetail;
  public tccDetails$: Observable<boolean>;
  public isApproved : boolean;
  public images : Base64Images;
  public acName: string;
  public division: string;
  public signature: string;
  public position: string;
  public tccPurpose:string;

  //private _tccno: string;
  

  get tccno():string{
    return this.downloadCertForm.get('tccno').value;
  }
  
  constructor( private fb:FormBuilder, private tccservice : TccDetailService) { 
    
  } 
  downloadCertForm = this.fb.group({tccno: ['',Validators.required]})
 
  ngOnInit() {
  /*   if(this.tccno!=null || this.tccno!=""){
    this.tccservice.getTccDetailsByTccno(this.tccno).subscribe(res => {
      
      this.tccdetail = this.tccservice.tccdetail;
      const purposeId:number = this.tccdetail.PURPOSE;
      this.tccservice.getPurposeById(purposeId).subscribe(p=>this.tccPurpose=p.PURPOSE_DESC)
    });
  } */
  }


  

  download(){
      this.tccservice.getTccDetailsByTccno(this.tccno).subscribe(res => {
      
      this.tccdetail = this.tccservice.tccdetail;
      const purposeId:number = this.tccdetail.PURPOSE;
      this.tccservice.getPurposeById(purposeId).subscribe(p=>{
        this.tccPurpose=p.PURPOSE_DESC;

        this.isApproved = (this.tccdetail.REQUEST_STATUS=="APPROVED");
      if(this.tccdetail!==null && this.isApproved){
        this.images = new Base64Images();
        if(this.tccdetail.TAX_DIVISION_NO==2 && (this.tccdetail.TAX_CENTER_NO==27 
          || this.tccdetail.TAX_CENTER_NO==28 
          || this.tccdetail.TAX_CENTER_NO==29)){
          this.division = "LARGE TAX DIVISION";
          this.acName = "ALVINA M.H. SHARPE";
          this.position = "MANAGER"
          this.signature = this.images.managerLargeTaxSignatureImg;
        }
        else if(this.tccdetail.TAX_DIVISION_NO==3 && (this.tccdetail.TAX_CENTER_NO==30 
          || this.tccdetail.TAX_CENTER_NO==31 
          || this.tccdetail.TAX_CENTER_NO==32)){
          this.division = "MEDIUM TAX DIVISION";
          this.acName = "SEBASTIAN A WEAH";
          this.position = "ASSISTANT COMMISSIONER"
          this.signature = this.images.asmtSignature;
        }
        else if((this.tccdetail.TAX_DIVISION_NO==4 
                || this.tccdetail.TAX_DIVISION_NO==25) && 
                (this.tccdetail.TAX_CENTER_NO==33 
                  || this.tccdetail.TAX_CENTER_NO==34 
                  || this.tccdetail.TAX_CENTER_NO==35)){
          this.division = "SMALL TAX DIVISION";
          this.acName = "H. BASHELU KROMAH, I";
          this.position = "ASSISTANT COMMISSIONER";
          this.signature = this.images.acstSignature;
        }
        else if(this.tccdetail.TAX_DIVISION_NO==39 && 
          (this.tccdetail.TAX_CENTER_NO==40 
            || this.tccdetail.TAX_CENTER_NO==41 
            || this.tccdetail.TAX_CENTER_NO==42)){
          this.division = "GOVERNMENT AND NOT-FOR-PROFIT";
          this.acName = "EDDIE H. HOWE";
          this.position = "ASSISTANT COMMISSIONER";
          this.signature = this.images.acgovtnotprofit;
        }
        else{
          this.division = "NATURAL RESOURCES";
          this.acName = "ATHELIA GRASCO KORVAH";
          this.position = "MANAGER";
          this.signature = this.images.naturalResources;
        }
        var doc = new jsPDF();
        
        doc.addImage(this.images.sealImg,10,10,20,20)
        doc.setFontSize(25);
        doc.setTextColor(237,28,36)
        doc.text("TAX CLEARANCE CERTIFICATE",38, 20);
        doc.addImage(this.images.lraImgData,180,10,20,15);
        doc.setFontSize(18);
        doc.setTextColor(0,0,128);
        doc.text(this.division,68, 30);
        doc.setFontSize(14);
        doc.setTextColor(0,0,0)
        doc.text("TCC NO#:",100, 40);
        doc.setFontSize(14);
        doc.setTextColor(237,28,36)
        doc.text(this.tccno,125, 40);
        doc.setTextColor(0,0,0)
        doc.text("Taxpayer Name:",10, 50);
        doc.text(this.wordWrap(this.tccdetail.TAXPAYER_NAME,56),50,47);
        doc.text("_____________________________________________________",47, 52);
        doc.text("Taxpayer Identification Number:",10, 60);
        doc.text(this.tccdetail.TIN,87,60);
        doc.text("________________________________________",82, 61);
        doc.text("Business Activities:",10, 70);
        doc.text(this.tccdetail.BUSINESS_ACTIVITY==null?"":this.tccdetail.BUSINESS_ACTIVITY,57,70);
        doc.text("___________________________________________________",53, 71);
        doc.text("Taxpayer Address:",10, 80);
        doc.text(this.tccdetail.ADDRESS==null?"":this.tccdetail.ADDRESS,57,80);
        doc.text("___________________________________________________",53, 81);
        doc.text("Taxpayer Email:",10, 90);
        doc.text(this.tccdetail.EMAIL==null?"":this.tccdetail.EMAIL,56,90);
        doc.text("_____________________________________________________",47, 91);
        doc.addImage(this.images.watermaskLogo,45,92,120,120)
        doc.text("Taxpayer Business Telephone No#:",10, 100);
        doc.text(this.tccdetail.BUSINESS_PHONE==null?"":this.tccdetail.BUSINESS_PHONE,90,100);
        doc.text("______________________________________",87, 101);
        doc.text("Taxpayer Approved Representative:",10, 110);
        doc.text(this.tccdetail.CONTACT_PERSON==null?"":this.tccdetail.CONTACT_PERSON,90,110);
        doc.text("_____________________________________",90, 111);
        doc.text("Representative Telephone No#:",10, 120);
        doc.text(this.tccdetail.PHONE==null?" ":this.tccdetail.PHONE,80,120);
        doc.text("________________________________________",82, 121);
        doc.text("Business Category:",10, 130);
        doc.text(this.tccdetail.TAXPAYER_TYPE,57,130);
        doc.text("___________________________________________________",49, 131);
        doc.text("THIS IS TO CERTIFY FROM INFORMATION AVAILABLE TO THE DOMESTIC TAX",10, 140);
        doc.text("DEPARTMENT THAT THE ABOVE MENTIONED TAXPAYER HAS QUALIFIED TO ",10, 145);
        doc.text("OBTAIN THIS TAX CLEARANCE AND IS HEREBY ISSUED THIS TAX CLEARANCE ",10, 150);
        doc.text("CERTIFICATE FOR THE PERIOD INDICATED BELOW:",50, 155);
        doc.text(this.tccdetail.NUMBER_OF_DAYS+" days",95,163);
        //doc.text(" days", 98, 163);
        doc.text("___________________________________________________",40, 165);
        doc.text("TAX PERIOD",90, 170);
        doc.text(this.wordWrap(this.tccPurpose,60),40,178);
        doc.text("___________________________________________________",40, 185);
        doc.text("PURPOSE",90, 190);
        doc.text("GIVEN UNDER OUR HAND AND SEAL THIS",50, 200);
        doc.text(this.tccdetail.ISSUE_DATE,90,209)
        doc.text("___________________________________________________",40, 210);
        doc.text("EXPIRES ON",89, 220);
        doc.text(this.tccdetail.EXPIRATION_DATE,90, 229)
        doc.text("___________________________________________________",40, 230);
        doc.text("SIGNATURE:",10, 245);
        doc.addImage(this.signature,45,235,50,15)
        doc.text("___________________________________________________",40, 245);
        doc.text(this.acName,41, 250);
        doc.text(this.position+", "+this.division,41, 255);
        doc.text("SIGNATURE:",10, 270);
        doc.addImage(this.images.actingCommissionerSignature,45,260,50,15)
        doc.text("___________________________________________________",40, 270);
        doc.text("MARGARET P. KROTE",41, 275);
        doc.text("ACTING COMMISSIONER, DOMESTIC TAX DEPARTMENT",41, 280);
        doc.save(""+this.tccno+".pdf");

      }
      else{
        alert("This Tax Clearance has not been Approved or it may have expired")
      }
      });
      
    });

     /*   */ 
  }

   wordWrap(str:string, maxWidth:number) {
    let newLineStr = "\n"; 
    let done = false; 
    let res = '';
    while (str.length > maxWidth) {                 
        let found = false;
        // Inserts new line at first whitespace of the line
        for (let i = maxWidth - 1; i >= 0; i--) {
            if (this.testWhite(str.charAt(i))) {
                res = res + [str.slice(0, i), newLineStr].join('');
                str = str.slice(i + 1);
                found = true;
                break;
            }
        }
        // Inserts new line at maxWidth position, the word is too long to wrap
        if (!found) {
            res += [str.slice(0, maxWidth), newLineStr].join('');
            str = str.slice(maxWidth);
        }

    }

    return res + str;
}

 private testWhite(x:string) {
    var white = new RegExp(/^\s$/);
    return white.test(x.charAt(0));
};
}
